import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import { SBAComboBox } from "../../UiComponents/SBADropDown";
import { TopBar } from "../../shared/topBar/TopBar";
import { SBDateRangePicker } from "../../UiComponents/SBDateRangePicker";
import download from '../../../Images/download.svg';
import { getEntityExceptions, getExceptionCategory, getExceptionAssets, getExceptionStatus, getEntityExceptionDetails, updateEntityException, getPrimaryAnalystDdl, getUserDetails } from "../../../config/apiConfig";
import { sbaAxios } from "../../utils/sbaAxios";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { ToastContainer, toast } from 'react-toastify';
import { SBNotify } from "../../utils/sbNotify";
import moment from "moment";
import { Modal } from 'react-bootstrap';
import { Tooltip } from "react-tooltip";
export const MonitoringView = () => {
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    const Level = [{ BreadCrumb: "Monitoring Exception", Routes: "/" }];
    const Gstate = useSelector(state => state) || {};
    const [StartDate, setStartDate] = useState(oneMonthAgo);
    const dispatch = useDispatch();
    const [EndDate, setEndDate] = useState(new Date());
    const [dateRange, setDateRange] = useState([new Date(StartDate), new Date(EndDate)]);
    const [gridata, setGriddata] = useState([]);
    const [Category, setCategory] = useState([]);
    const [selectedCategory, setselectedCategory] = useState([]);
    const [showDrawer, setShowDrawer] = useState(false);
    const [selectedMonitoringAnalyst, setSelectedMonitoringAnalyst] = useState();
    const [selectedAsset, SetselectedAsset] = useState([]);
    const [Assets, setAssets] = useState([]);
    const [status, setStatus] = useState([]);
    const [selectedStatus, setselectedStatus] = useState({
        "EnumValue": 1,
        "EnumName": "Open",
        "EnumShortName": "Open",
        "EnumDescription": "",
        "SortOrder": 1
    });
    const [issign, setissign] = useState(false);
    const [Editdata, setEditdata] = useState([]);
    const [entityExceptionId, setEntityExceptionId] = useState(0);
    const [entityExceptionType, setEntityExceptionType] = useState(0);
    const [Notify, setNotify] = useState([]);
    const [Tolerance, setTolerance] = useState([]);
    const [selectedNotes, setselectedNotes] = useState([]);
    const [Analysts, setAnalysts] = useState([]);
    const [userdetails, setuserdetails] = useState([]);
    const [signoffIds, setSignOffIds] = useState([]);
    const [showSignOffDrawer, setshowSignOffDrawer] = useState(false);
    const [selectedsignoffNotes, setselectedsignoffNotes] = useState([]);
    useEffect(() => {
        document.title = `Monitoring Exception`;
    }, []);
    const handleDateChange = (e) => {
        const newStartDate = e?.value?.start  instanceof Date ? e.value.start : dateRange[0];
        const newEndDate = e?.value?.end instanceof Date? e.value.end : dateRange[1];
        setDateRange([newStartDate, newEndDate])
        setStartDate(moment(newStartDate).format("MM-DD-yyyy"));
        setEndDate(moment(newEndDate).format("MM-DD-yyyy"));
    };
    const defaultColDef = {
        sortable: false,
        floatingFilter: true,
        suppressMovable: true,
        flex: 1,
        resizable: true
    };
    useEffect(() => { GetUserDetails(); }, [issign])
    useEffect(() => {
        fetchEntityException();
        GetExceptionAssets();
        GetExceptionStatus();
        GetCExceptionategory();
        GetMonitoringanalysist();

    }, [])
    const GetExceptionTypeDetails = async (exceptionTypeId) => {
        try {
            const response = await sbaAxios({

                url: `${getEntityExceptionDetails}/${exceptionTypeId}`,
                method: 'get',
            })
            if (response) {
                setEditdata(response?.Exception);
                setNotify(response?.ExceptionNotification);
                setTolerance(response?.ExceptionEntTolerance)
                setselectedNotes(response?.Exception.Notes)
                setissign(response?.Exception.SignOffUserId !== 0);
            }
        }
        catch (error) {

        }
    }

    const GetUserDetails = async () => {
        try {
            const response = await sbaAxios({

                url: `${getUserDetails}`,
                method: 'get',
            })
            if (response) {
                setuserdetails(response);
            }
        }
        catch (error) {

        }

    }
    
    const fetchEntityException = async () => {
        sbaAxios({

            url: `${getEntityExceptions}?fromDate=${StartDate}&toDate=${EndDate}&statusId=${selectedStatus?.EnumValue || null}&primaryAnalystId=${selectedMonitoringAnalyst?.UserId || null}
           &exceptionCategoryId=${selectedCategory?.ExceptionCategoryId || null}&entityId=${selectedAsset?.AssetId || null}`,
            method: 'get',
        }).then(res => {
            setGriddata(res);

        }).catch(error => {
            setGriddata([]);
        })
    }
    const GetEntityExceptions = async () => {
        try {
            const response = await sbaAxios({

                url: `${getEntityExceptions}?fromDate=${StartDate}&toDate=${EndDate}&statusId=${selectedStatus.EnumValue}&primaryAnalystId=${selectedMonitoringAnalyst.UserId}
               &exceptionCategoryId=${selectedCategory.ExceptionCategoryId}&entityId=${selectedAsset.AssetId}`,
                method: 'get',
            })
            if (response) {
                setGriddata(response);
            }
        }
        catch (error) {

        }
    }
    const GetMonitoringanalysist = async () => {
        try {
            const response = await sbaAxios({

                url: `${getPrimaryAnalystDdl}`,
                method: 'get',
            })
            if (response) {
                const value = [
                    {
                        UserId: null,
                        AnalystName: "--Please Select--"
                    },
                    ...response
                ];
                setAnalysts(value);
                setSelectedMonitoringAnalyst(value[0]);
            }
        }
        catch (error) {

        }

    }
    const GetExceptionStatus = async () => {
        try {
            const response = await sbaAxios({

                url: `${getExceptionStatus}`,
                method: 'get',
            })
            if (response) {
                const value = [
                    { EnumName: "--- Please Select ---", EnumValue: null },
                    ...response
                ];
                setStatus(value);
                setselectedStatus(value[1]);
            }
        }
        catch (error) {

        }

    }
    const GetCExceptionategory = async () => {

        try {
            const response = await sbaAxios({

                url: `${getExceptionCategory}`,
                method: 'get',
            })
            if (response) {
                const value = [
                    { ExceptionCategoryName: "--- Please Select ---", ExceptionCategoryId: null },
                    ...response
                ];

                setCategory(value);
                setselectedCategory(value[0])

            }
        }
        catch (error) {

        }
    }
    const GetExceptionAssets = async () => {

        try {
            const response = await sbaAxios({

                url: `${getExceptionAssets}`,
                method: 'get',
            })
            if (response) {

                const value = [
                    { AssetName: "--- Please Select ---", AssetId: null },
                    ...response
                ];

                setAssets(value);
                SetselectedAsset(value[0]);

            }
        }
        catch (error) {

        }
    }
    const Categoryonchange = (e) => {
        setselectedCategory(e.value);
    }
    const MonitoringChange = (e) => {
        setSelectedMonitoringAnalyst(e.value);
    }
    const valuformaterapply = (params) => {
        return moment(params.value).format("MM/DD/YYYY");
    }
    const onEditButtonClick = (e) => {

        console.log(e.data);
        GetExceptionTypeDetails(e.data.EntityExceptionId);
        setEntityExceptionId(val => e.data.EntityExceptionId);
        setEntityExceptionType(val => e.data.ExceptionTypeName);
        setShowDrawer(true);

    }
    const Enterclk = () => {
        GetEntityExceptions();
        setSignOffIds([]);
    }
    const ActionsRenderer = (event) => {

        return (
            <div className="actions-cell">
                <i onClick={(e) => { onEditButtonClick(event) }}
                    className="fas fa-edit" style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}></i>
            </div>
        );
    };
    const handleUpdate = async () => {
        let issave = true;
        const userid = Editdata.SignOffUserId ? Editdata.SignOffUserId : userdetails.UserId;
        const savedata = {
            entityExceptionId: entityExceptionId,
            signOffUserId: issign ? userid : 0,
            notes: selectedNotes || ""
        };

        if (issave) {
            try {
                const res = await sbaAxios({
                    url: updateEntityException,
                    method: "post",
                    data: savedata
                });

                SBNotify({ Msg: "Exception Saved Successfully", type: "success" });
                setShowDrawer(false);
                GetEntityExceptions();
                setEntityExceptionId(0);
                setEntityExceptionType(val => "");
            } catch (error) {
                console.error("Axios error:", error);
                setEntityExceptionId(0);
                setEntityExceptionType(val => "");
                SBNotify({ Msg: "Network Error: " + error.message, type: "error" });
            }
        }

    }

    const CheckBoxRender  = (props) => {
        const onChange = async(event) => {
            const chkValue = event.target.checked;
            const newValue = chkValue === true ? 1 : 0
            props.node.setDataValue(props.colDef.field, newValue);
            props.api.refreshCells({ rowNodes: [props.node], columns: [props.colDef.field] });
            const response = await  sbaAxios({
                url: `${getEntityExceptionDetails}/${props.data.EntityExceptionId}`,
                method: 'get',
            })
            if(chkValue)
            {
                setSignOffIds(prev => {
                    return [
                        ...prev,
                        {
                            EntityExceptionId: response?.Exception.EntityExceptionId,
                          NavDate:  response?.Exception.NavDate,
                          EntityName:  response?.Exception.EntityName,
                          ExceptionCategoryName:  response?.Exception.ExceptionCategoryName,
                          ExceptionTypeName:  response?.Exception.ExceptionTypeName,
                          SignOffUserId:  response?.Exception.SignOffUserId ?  response.Exception.SignOffUserId : userdetails.UserId
                        }
                      ];
                    }
                ); 
            }
            else 
            {
                setSignOffIds(prev => {
                    return [
                        ...prev.filter(item=>item.EntityExceptionId!==response?.Exception.EntityExceptionId)];
                    }
                ); 
            }
            // setSignOffIds(prev => {
            //     // Locate the item (if any) whose entityExceptionId matches the current row
            //     const idx = prev.findIndex(
            //       item => item.entityExceptionId === props.data.EntityExceptionId
            //     );
              
            //     if (chkValue) {
            //       // ### Ticked (sign‑off) ###
            //       if (idx !== -1) {
            //         // It’s already there → just update UserId
            //         return prev.map((item, i) =>
            //           i === idx ? { ...item, UserId: response?.Exception?.SignOffUserId ? Editdata.SignOffUserId : userdetails.UserId } : item
            //         );
            //       }
              
            //       // Not there → add a new record
            //       return [
            //         ...prev,
            //         {
            //             EntityExceptionId: response?.Exception.EntityExceptionId, // keep the key!
            //           NavDate:  response?.Exception.NavDate,
            //           EntityName:  response?.Exception.EntityName,
            //           ExceptionCategoryName:  response?.Exception.ExceptionCategoryName,
            //           ExceptionTypeName:  response?.Exception.ExceptionTypeName,
            //           SignOffUserId:  response?.Exception.SignOffUserId ?  response.Exception.SignOffUserId : userdetails.UserId
            //         }
            //       ];
            //     } else {
            //       // ### Unticked (undo sign‑off) ###
            //       if (idx === -1) return prev; // nothing to undo
              
            //       // Zero‑out the UserId of the existing record
            //       return prev.map((item, i) =>
            //         i === idx ? { ...item, UserId: 0 } : item
            //       );
            //     }
            //   });
              
        };

        return (
            <div className="actions-cell">
                <input
                    type="checkbox"
                    className="mb-0"
                    checked={props.value === 1 ? true : false} 
                    onChange={onChange}
                />
            </div>
        );
    };
    const Bulksignoff = async () => {
        if (signoffIds.length === 0) {
            SBNotify({ Msg: "Please select at least one item.", type: "error" });
            return;
        }
        try {
            if (!signoffIds[0].Notes) {
                SBNotify({ Msg: "Please Enter the Note.", type: "error" });
                return;
            }
            else
            {
            await Promise.all(
                signoffIds.map(async (item) => {
                    const res = await sbaAxios({
                        url: updateEntityException,
                        method: "post",
                        data: item
                    });

                    // SBNotify({ Msg: "Exception Saved Successfully", type: "success" });
                })
            );

            // After all requests succeed
            GetEntityExceptions();
            setEntityExceptionId(0);
            setEntityExceptionType(() => "");
            setshowSignOffDrawer(false);
            setSignOffIds([]);
            }
        } catch (error) {
            console.error("Axios error:", error);
            setEntityExceptionId(0);
            setEntityExceptionType(() => "");
            setshowSignOffDrawer(false);
            SBNotify({ Msg: "Network Error: " + error.message, type: "error" });
        }
    }
    const updateAllNotes = (newNotes) => {
        setselectedsignoffNotes(newNotes);
        setSignOffIds(prev =>
            prev.map(item => ({
                ...item,
                Notes: newNotes
            }))
        );
    };
    const ColumnDefs = [
        { headerName: 'SignOff', field: 'SignOffUserId', cellRenderer: CheckBoxRender, maxWidth:100  },
        { headerName: 'Asset', field: 'EntityName', filter: "agTextColumnFilter", },
        {
            headerName: 'Nav Date',
            field: 'NavDate',
            valueFormatter: valuformaterapply,
            filter: "agTextColumnFilter"


        },
        { headerName: 'Exception Category', field: 'ExceptionCategoryName', filter: "agTextColumnFilter", },
        { headerName: 'Exception Analyst', field: 'PrimaryAnalystName', filter: "agTextColumnFilter", },
        {
            headerName: 'Exception',
            field: 'ExceptionTypeName',
            filter: "agTextColumnFilter",

        },
        {
            headerName: 'Est/Act',
            field: 'EstAct',
            filter: "agTextColumnFilter",

        },
        {
            headerName: 'Status',
            field: 'StatusName',
            filter: "agTextColumnFilter",

        },
        {
            field: "Action",
            headerName: "Action",
            cellRenderer: ActionsRenderer,
            filter: "agTextColumnFilter",
            maxWidth: 130,
        },

    ];
    const DetColumnDefs = [
        {
            headerName: 'Exception',
            field: 'Exception',

        },
        {
            headerName: 'BenchMark',
            field: 'BenchMark',

        },
        {
            headerName: 'Tolerance Value Range',
            field: 'ToleranceValueRange',

        }, {
            headerName: 'Tolerance Value Type',
            field: 'ToleranceValueType',

        },

    ]

    const handleCancel = () => {
        setShowDrawer(false);
    };

    const SignOffColumnDefs = [
        {
            headerName: 'Nav Date',
            field: 'NavDate',
            valueFormatter: valuformaterapply,
            filter: "agTextColumnFilter"


        },
        { headerName: 'Asset', field: 'EntityName', filter: "agTextColumnFilter", },
       
        { headerName: 'Category', field: 'ExceptionCategoryName', filter: "agTextColumnFilter", },
       
        {
            headerName: 'Exception',
            field: 'ExceptionTypeName',
            filter: "agTextColumnFilter",

        },
        
        

    ];

    const chkbulksignoff = () =>
    { 
        setshowSignOffDrawer(true);
        setselectedsignoffNotes([]);
    }
    return <>

        <div>
            <TopBar label={"Monitoring Exceptions"} />
            <BreadCrumbs Levels={Level} />
            <div className="mainContentData">
                <div className="bg-white m-4 mb-3 p-3 border rounded ">
                    <form action="#">
                        <div className="row" >
                            <div className="col-md-3">
                                <label
                                    for="select fund"
                                    className="mb-1 ms-2 fw-semibold fs-12"
                                >
                                    Date Range
                                </label>
                                <SBDateRangePicker
                                    value={{ start: dateRange[0], end: dateRange[1] }}
                                    onChange={(e) => { handleDateChange(e) }}

                                />

                            </div>
                            <div className="col-md-3">
                                <label
                                    for="select fund"
                                    className="mb-1 ms-2 fw-semibold fs-12"
                                >
                                    Category
                                </label>
                                <div>
                                    <SBAComboBox
                                        className="w-75"
                                        data={Category}
                                        textField={"ExceptionCategoryName"}
                                        valueField={"ExceptionCategoryId"}
                                        value={selectedCategory}
                                        onChange={Categoryonchange}


                                    />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <label
                                    for="select fund"
                                    className="mb-1 ms-2 fs-12 fw-semibold d-block"
                                >
                                    Monitoring Analyst
                                </label>
                                <SBAComboBox
                                    className="w-75"
                                    value={
                                        selectedMonitoringAnalyst
                                    }
                                    textField={"AnalystName"}
                                    valueField={"UserId"}
                                    onChange={MonitoringChange}
                                    data={Analysts}

                                />
                            </div>
                            <div className="col-md-3">
                                <label
                                    for="select fund"
                                    className="mb-1 ms-2 fw-semibold  fs-12 d-block"
                                >
                                    Asset
                                </label>
                                <SBAComboBox
                                    onChange={(e) => { SetselectedAsset(e.value) }}
                                    value={selectedAsset}
                                    className="AssetDropDown input-default"
                                    textField={"AssetName"}
                                    valueField={"AssetId"}
                                    data={Assets}
                                />
                            </div>
                            <div className="col-md-3">
                                <label
                                    for="select fund"
                                    className="mb-1 ms-2 fw-semibold  fs-12 d-block"
                                >
                                    Status
                                </label>
                                <SBAComboBox
                                    className="w-75"
                                    data={status}
                                    textField={"EnumName"}
                                    valueField={"EnumValue"}
                                    onChange={(e) => { setselectedStatus(e.value) }}
                                    value={selectedStatus}
                                />
                            </div>

                            <div className="col-md-3 mt-3">
                                <button
                                    type="button"
                                    className="enter-btn"
                                    onClick={Enterclk}
                                >
                                    Enter
                                </button>
                            </div>
                        </div>

                    </form>
                </div>
                <div>
                    <div className="mx-4 p-3">
                        <div className="row">
                            <div class="col-lg-12 col-md-12 bg-white  rounded">
                                <div className="d-flex justify-content-end gap-2">
                                    <button type="button" className="p-sm-btn mx-1"><img src={download} alt="" />Export</button>
                                    <button type="button" className="p-sm-btn mx-1" onClick={chkbulksignoff} >Bulk SignOff</button>
                                </div>
                                <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}>
                                    <AgGridReact rowData={gridata} columnDefs={ColumnDefs} defaultColDef={defaultColDef} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <SBADrawer
                    open={showDrawer}
                    setOpen={setShowDrawer}
                    close={false}
                    title={"Update Exception"}
                >
                    <div className="row m-0 my-3">
                        <div className="row align-items-center">
                            <div className="col-md-5">
                                <div className="col-auto ">
                                    <input
                                        type="checkbox"
                                        checked={issign}
                                        onChange={() => {
                                            setissign(!issign);
                                        }}

                                    />

                                    <span className="fw-medium ps-4 me-2" >Sign off</span>

                                    {issign && Editdata.SignOffUserName && (
                                        <span className="fw-medium">({Editdata.SignOffUserName})</span>
                                    )}

                                </div>

                            </div>

                            <div className="col-md-5">
                            </div>
                        </div>

                        <div className="row align-items-center mb-3 mt-3">
                            <label className='label'>Note</label>

                            <div className="mt-2" >
                                <textarea id="txtNote" className="form-control" rows={4}
                                    value={selectedNotes}
                                    onChange={(e) => setselectedNotes(e.target.value)}

                                >
                                </textarea>
                            </div>
                        </div>

                        <div className="m-1 d-flex justify-content-end mt-2">
                            <button className="s-sm-btn mx-1" onClick={handleCancel}
                            >Cancel</button>
                            <button className="p-sm-btn mx-1" onClick={handleUpdate}>Save</button>
                        </div>
                        <div className="h5 mb-3">
                            Exception Tolerance
                        </div>
                        <div className="row mb-4">
                            <label className="header-container m-1">Exception Type</label>

                            <div>
                                <input
                                    className="form-control w-75"
                                    type="text"
                                    value={entityExceptionType}
                                    disabled
                                />
                            </div>

                        </div>
                        <div className="row mb-4">
                            <label className="header-container m-1">Exception Value Type</label>

                            <div>
                                <input
                                    className="form-control w-75"
                                    type="text"
                                    value={Tolerance?.ExceptionValueTypeName}
                                    disabled
                                />
                            </div>

                        </div>
                        <div className="row mb-4">
                            <div className="col-md-4">
                                <label className="header-container m-1">
                                    Min Value
                                </label>
                                <div>
                                    <input
                                        className="form-control w-75"
                                        type="text"
                                        value={Tolerance?.MinValue}
                                        disabled

                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <label className="header-container m-1">
                                    Max Value
                                </label>
                                <div>
                                    <input
                                        className="form-control w-75"
                                        type="text"
                                        disabled
                                        value={Tolerance?.MaxValue}
                                    />
                                </div>

                            </div>
                            <div className="col-md-4">
                                <label className="header-container m-1">
                                    Actual Value
                                </label>
                                <div>
                                    <input
                                        className="form-control w-75"
                                        type="number"
                                        disabled
                                        value={
                                            Editdata?.ExceptionValue !== undefined && Editdata?.ExceptionValue !== null
                                                ? parseFloat(Editdata.ExceptionValue).toFixed(2)
                                                : ''
                                        }
                                    />
                                </div>

                            </div>


                        </div>

                        <div className="h5 mb-3">
                            Exception Notification
                        </div>

                        <div className="row mb-4">
                            <label className="header-container m-1">
                                Notification Category
                            </label>
                            <div>
                                <input
                                    className="form-control w-75"
                                    type="text"

                                    value={Notify?.ExceptionNotifCategoryName}

                                />
                            </div>


                        </div>
                        <div className="row mb-4">
                            <label className="header-container m-1">
                                Subject
                            </label>
                            <div>
                                <input
                                    className="form-control w-75"
                                    type="text"

                                    value={Notify?.Subject}

                                />
                            </div>
                        </div>
                        <div className="row mb-4">
                            <label className="header-container m-1">
                                Message
                            </label>
                            <div>
                                <textarea
                                    className="form-control w-75"
                                    rows={4}
                                    value={Notify?.Message}
                                />

                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="col-auto">
                                <input
                                    type="checkbox"
                                    checked={Notify?.IsProcessed}

                                />
                            </div>
                            <div className="col-auto">
                                <span className="fw-medium">Is Processed</span>
                            </div>

                        </div>
                    </div>

                </SBADrawer>
                <SBADrawer
                    open={showSignOffDrawer}
                    setOpen={setshowSignOffDrawer}
                    close={false}
                    title={"Bulk Sign-Off"}
                >
                    <div className="row m-0 my-3">
                       
                    <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}>
                                    <AgGridReact rowData={signoffIds} columnDefs={SignOffColumnDefs} defaultColDef={defaultColDef} />
                                </div>
                                <div className="row align-items-center mb-3 mt-3">
                            <label className='label'>Notes</label>

                            <div className="mt-2" >
                                <textarea id="txtNote" className="form-control" rows={4}
                                    value={selectedsignoffNotes}
                                    onChange={(e) => updateAllNotes(e.target.value)}

                                >
                                </textarea>
                            </div>
                        </div>
                        <div className="m-1 d-flex justify-content-end mt-2">
                            <button className="s-sm-btn mx-1" onClick={()=>setshowSignOffDrawer(false)}
                            >Cancel</button>
                            <button className="p-sm-btn mx-1" onClick={Bulksignoff}>Save</button>
                        </div>
                      
                    </div>

                </SBADrawer>
            </div>
          
            <ToastContainer></ToastContainer>
        </div>
    </>

}